import { Box } from '@mui/material';
import Pagination from 'components/controls/Pagination';
import Loading from 'components/common/Loading';
import React, { useEffect } from 'react';
import { object, string } from 'prop-types';
import { MANDATORY_ACKNOWLEDGES_LIMIT } from 'services/api/Mandatory';
import ReadProgressBar from './ReadProgressBar';
import AcknowledgeList from './AcknowledgeList';
import connector from './connector';
import SendToAllButton from './SendToAllButton';

const Analytics = ({ actions, mandatoryId, message, analyticsDrawer: { fullMandatory } }) => {
  useEffect(() => {
    actions.drawer.analyticsDrawer.fullMandatory.load(mandatoryId, 1);
  }, [actions, mandatoryId]);

  const handleSend = employee => {
    actions.drawer.analyticsDrawer.fullMandatory.remind(mandatoryId, employee);
  };

  const changePage = ({ selected: page }) => {
    actions.drawer.analyticsDrawer.fullMandatory.load(mandatoryId, page + 1);
  };

  if (!fullMandatory) return null;

  if (fullMandatory.loading) return <Loading />;

  if (!fullMandatory.mandatory) return 'Error';

  const {
    mandatory: { acknowledges, employeesReadCount, employeesTotalCount, employees },
    page,
  } = fullMandatory;

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          borderRadius: '5px',
          display: 'flex',
          border: '1px solid #ebeff0',
          p: '15px',
        }}
      >
        <ReadProgressBar read={employeesReadCount} total={employeesTotalCount} />
        <SendToAllButton onSend={handleSend} total={employeesTotalCount - employeesReadCount} />
      </Box>
      <AcknowledgeList
        onSend={handleSend}
        acknowledges={acknowledges}
        employees={employees}
        message={message}
      />
      <Pagination
        page={page - 1}
        perPage={MANDATORY_ACKNOWLEDGES_LIMIT}
        total={employeesTotalCount}
        onChange={changePage}
      />
    </Box>
  );
};

Analytics.propTypes = {
  actions: object.isRequired,
  mandatoryId: string.isRequired,
  message: object.isRequired,
  employees: object.isRequired,
  analyticsDrawer: object.isRequired,
};

export default connector(Analytics);
